import React from 'react';
import '../style/ComicList.css'; 
import { Link } from 'react-router-dom';

const ComicList = ({ comics }) => {
  const handleReadComic = (comic) => {
    // Lấy dữ liệu lịch sử đọc từ localStorage
    const readingHistory = JSON.parse(localStorage.getItem('readingHistory')) || [];
    
    // Kiểm tra nếu comic đã có trong lịch sử đọc chưa
    if (!readingHistory.includes(comic.name)) {
      // Thêm truyện vào lịch sử đọc
      readingHistory.push(comic.name);
      // Lưu lại vào localStorage
      localStorage.setItem('readingHistory', JSON.stringify(readingHistory));
    }
  };

  return (
    <div className="comic-list">
      {comics.length === 0 ? (
        <p>Không có truyện nào để hiển thị.</p>
      ) : (
        comics.map((comic) => (
          <div key={comic._id} className="comic-item">
            <Link to={`/comics/${comic.slug}`} onClick={() => handleReadComic(comic)}>
              <div className="comic-thumbnail-wrapper">
                <img 
                  src={`https://img.otruyenapi.com/uploads/comics/${comic.thumb_url}`} 
                  alt={comic.name || 'No title available'}
                  className="comic-thumbnail" 
                />
                <div className={`comic-status ${comic.status}`}>
                  {comic.status === 'coming_soon' ? 'Sắp ra mắt' : 
                   comic.status === 'ongoing' ? 'Đang cập nhật' : 
                   comic.status === 'completed' ? 'Hoàn thành' : 
                   'Chưa có trạng thái'}
                </div>
              </div>
            </Link>
            <div className="comic-info">
              <h2>{comic.name || 'Không có tiêu đề'}</h2>
              {comic.chaptersLatest && comic.chaptersLatest.length > 0 && (
                <p>Chương mới nhất: {comic.chaptersLatest[0]?.chapter_name || 'N/A'}</p>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ComicList;
